import React from 'react';
import { useTranslation } from 'react-i18next';
import HeroSection from '../../components/sections/HeroSection';
import BigTinyIntroSection from '../../components/sections/BigTinyIntroSection';
import OnePlusTwoGallery from '../../components/sections/OnePlusTwoGallery';
import FaqAccordionsSection from '../../components/sections/FaqAccordionsSection';
import FactsAndStatsSection from '../../components/sections/FactsAndStatsSection';
import PracticalInfoSection from '../../components/sections/PracticalInfoSection';
import ArticleWithModal from '../../components/sections/ArticleWithModal';
import VisaServicesPromotion from '../../components/sections/VisaServicesPromotion';
import FooterSection from '../../components/sections/FooterSection';
import DividersInfoSection from '../../components/sections/DividersInfoSection';
import ParallaxCallSection from '../../components/sections/ParallaxCallSection';

function AktauCityPage(props) {

    var { t } = useTranslation();

    React.useEffect(function () {
        if (window.UIkit !== undefined) {
            window.UIkit.update();
        }
    }, []);

    var faqItems = [
        { question: "What documents are required?", answer: "Passport valid for at least 6 months, visa application form, passport photos, proof of accommodation, and travel insurance are standard requirements." },
        { question: "How long does processing take?", answer: "Standard processing usually takes up to 5 working days, while express processing can be completed in 48 hours depending on consular workload." },
        { question: "Can business delegations apply?", answer: "Yes, corporate visa packages are available for delegations, including bulk submissions, account-based invoicing, and consolidated document delivery." },
        { question: "Is visa on arrival available?", answer: "Visa on arrival is limited to specific cases. Pre-application ensures guaranteed entry and avoids administrative delays at the border." }
    ];


    return (
        <div className="">

            <HeroSection
                isExpectingAnimations={true}
                i18nTitleKey="mangistau.hero.title"
                i18nParagraphKey="mangistau.hero.paragraph"
                i18nCallToActionKey="mangistau.hero.cta"
                backgroundImageUrl="https://kompastour.com/useruploads/regions/region_3449cdc59f.jpg"
            />

            <div className='uk-container'>

                <BigTinyIntroSection
                    centered={false}
                    Big="Aktau is the ideal destination for professionals looking to combine career growth with an enjoyable lifestyle. Through Jai, obtaining the necessary visas and work permits is simple, allowing you to focus on opportunities in trade, logistics, and related industries while settling in quickly."
                    Tiny="Beyond professional engagements, Aktau offers golden beaches, lively streets, and engaging cultural experiences. With Jai supporting your relocation and visa process, you can confidently explore the city, enjoy its vibrant lifestyle, and make the most of both work and leisure during your stay."
                />

                <section className="uk-grid-large uk-child-width-1-2@s uk-flex-middle" data-uk-grid>
                    <div>
                        <h1 className="uk-heading-medium uk-text-bold uk-margin-remove">
                            {t('Aktau — Gateway to the Caspian Sea')}
                        </h1>

                        <p className="uk-text-lead uk-margin-small-top">
                            Aktau is located on the eastern shore of the Caspian Sea. The city functions as Kazakhstan's primary maritime node and serves strategic roles in oil, logistics, and international trade corridors connecting Central Asia with Europe and the Caucasus.
                        </p>

                        <p>
                            Established in the 1960s as an oil-and-gas industry centre, Aktau developed infrastructure for tanker logistics, bulk cargo handling, and specialised maritime services. Modern Aktau combines industrial utility with coastal leisure: pebble and sandy beaches, sea promenades, and viewpoints that frame dramatic sunsets over the Caspian basin.
                        </p>

                        <p>
                            The surrounding Mangistau region features karst plateaus, ancient necropolises, and subterranean mosques carved into limestone. These geological and historical assets make Aktau a practical base for both business delegations and exploratory tourism itineraries.
                        </p>

                        <VisaServicesPromotion />
                    </div>

                    {/* Блок с картинками */}
                    <OnePlusTwoGallery
                        BigImageLink="https://caspianpost.com/storage/photos/thumbs/large/gUqmSyxIyahWtSngfbIYLB4amu6qOgJJgtyK3xNI.webp"
                        BigImageDescription="Aktau coastline"
                        SmallImage1Link="https://www.orexca.com/img/kazakhstan/aktau/aktau.jpg"
                        SmallImage1Description="Aktau seafront"
                        SmallImage2Link="https://weproject.media/media/userfiles/images/f_azh_kz(2).jpg"
                        SmallImage2Description="Aktau cityscape"
                    />

                </section>
            </div>

            <ParallaxCallSection
                URL="https://www.ahstatic.com/photos/b7r0_ho_00_p_1024x768.jpg"
                headline="Start Your Journey to Aktau Today!"
                callToAction="Fast processing, professional guidance, and guaranteed compliance for your Kazakhstan visa, only with Jai!"
            />

            <div className='uk-container'>

                {/* Three cards section */}
                <section className="uk-grid-large uk-child-width-1-3@m uk-margin-large-top" data-uk-grid>

                    <ArticleWithModal
                        Image="https://portaktau.kz/wp-content/uploads/2021/03/fotogalereya-1.jpg"
                        ImageDescription="Aktau landscape"
                        ArticleTitle="infopages.cities.aktau.articleModal1.title"
                        Paragraph1="infopages.cities.aktau.articleModal1.paragraph1"
                        Paragraph2="infopages.cities.aktau.articleModal1.paragraph2"
                        Paragraph3="infopages.cities.aktau.articleModal1.paragraph3"
                        Paragraph4="infopages.cities.aktau.articleModal1.paragraph4"
                        Paragraph5="infopages.cities.aktau.articleModal1.paragraph5"
                        modalName="modal-business1"
                    />

                    <ArticleWithModal
                        Image="https://www.tripsofourlife.com/wp-content/uploads/2024/12/exofyllo1-1080x675.jpg"
                        ImageDescription="Mangystau landscape"
                        ArticleTitle="infopages.cities.aktau.articleModal2.title"
                        Paragraph1="infopages.cities.aktau.articleModal2.paragraph1"
                        Paragraph2="infopages.cities.aktau.articleModal2.paragraph2"
                        Paragraph3="infopages.cities.aktau.articleModal2.paragraph3"
                        Paragraph4="infopages.cities.aktau.articleModal2.paragraph4"
                        Paragraph5="infopages.cities.aktau.articleModal2.paragraph5"
                        modalName="modal-business2"
                    />

                    <PracticalInfoSection
                        sectionTitle="Practical Information"
                        currencyInfo="Local currency: Kazakhstani tenge (KZT)."
                        airportInfo="Primary airport: Aktau International Airport (regional and limited international flights)."
                        climateInfo="Climate: arid continental; hot summers, cool winters; sea moderates coastal temperatures."
                        businessHoursInfo="Business hours: most government offices operate Monday–Friday, typically 09:00–18:00 local time."
                    />
                </section>
                
            </div>

            {/* Quick Facts / Statistics */}
            <FactsAndStatsSection
                sectionTitle="Quick Facts"
                stat1="90%"
                fact1="Visa approval rate"
                stat2="635+"
                fact2="Clients served"
                stat3="14"
                fact3="Days processing time"
                stat4="1960"
                fact4="Year city founded"
            />

            <div className="uk-section uk-container">
                <div className="uk-text-center">
                    <h2 className="uk-h2 uk-text-bold">Workforce Opportunities in a Strategic Hub</h2>
                    <p className="uk-text-lead">
                        As Kazakhstan's main Caspian port, Aktau offers a dynamic job market for foreign specialists, driven by its oil and gas sector, international trade, and large-scale infrastructure projects.
                    </p>
                </div>

                <div className="uk-child-width-1-3@m uk-grid-match uk-margin-medium-top" data-uk-grid>
                    <div>
                        <div className="uk-card uk-card-body uk-card-hover uk-card-default">
                            <div className="uk-card-badge uk-label">High Demand</div>
                            <h3 className="uk-card-title"><span data-uk-icon="icon: world; ratio: 1.2" className="uk-margin-small-right"></span>Oil, Gas & Logistics</h3>
                            <p>The backbone of Aktau's economy. Opportunities are abundant for engineers, project managers, and logistics coordinators in port operations, maritime services, and energy-related construction. International experience is highly valued.</p>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-body uk-card-hover uk-card-default">
                            <h3 className="uk-card-title"><span data-uk-icon="icon: bolt; ratio: 1.2" className="uk-margin-small-right"></span>Skilled Trades & Construction</h3>
                            <p>Ongoing industrial and urban expansion creates consistent demand for certified welders, electricians, mechanics, and construction supervisors. Foreign contractors are frequently sought for specialized projects requiring advanced skills.</p>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-body uk-card-hover uk-card-default">
                            <h3 className="uk-card-title"><span data-uk-icon="icon: desktop; ratio: 1.2" className="uk-margin-small-right"></span>Business Support & IT</h3>
                            <p>The growth of international companies in the region fuels a need for professionals in finance, compliance, auditing, and IT. Specialists in enterprise software, cybersecurity, and network administration are needed to support complex industrial operations.</p>
                        </div>
                    </div>
                </div>
            </div>


            {/* FAQ Accordion */}
            <FaqAccordionsSection
                items={faqItems}
            />

            <div className='uk-container'>
                {/* Infosection with shitloads of dividers */}
                <DividersInfoSection />
            </div>

            <FooterSection />
        </div>
    );
}

export default AktauCityPage;
